module.exports = __webpack_public_path__ + "static/media/Kylling.b5fb45e4.PNG";